module.exports = __webpack_public_path__ + "static/media/internships.af95096b.svg";